<div class="center{{!readonly?'-sm':''}}">
    <select class="form-control-sm" #select [value]="value?.currency" (change)="emitValue(select.value || '');">
        <option value="MXN">MXN</option>
        <option value="USD">USD</option>
    </select>
    <div class="cursor-pointer text-overflow" [class._input]="!readonly" *ngIf="!focus" (click)="!readonly ? this.setFocus(true) : {}">
        <span class="text-overflow">{{value?.value | currency}}</span>
    </div>
        <input #input type="text" *ngIf="focus" [value]="value?.value" placeholder="Aa..." (blur)="setFocus(false)" (change)="emitValue(input.value || ''); setFocus(false)">
</div>